import React, { forwardRef, useEffect, useState } from 'react'
import styles from './index.module.less'
import clsx from 'clsx'

const SwitchIcon = ({
  onClick,
  className,
  open,
}: {
  onClick?: (status: any) => void
  className?: string
  open?: boolean
}, ref) => {
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    setIsOpen(open)
  }, [open])

  const toggleMenu = () => {
    const status = !isOpen
    setIsOpen(status)
    onClick?.(status)
  }

  return (
    <div
      ref={ref}
      className={clsx(styles['menu-icon'], isOpen ? styles['open'] : '', className)}
      onClick={toggleMenu}
    >
      <span></span>
      <span></span>
      <span></span>
    </div>
  )
}

export default forwardRef(SwitchIcon)
